import { returnEmptySearchMsg } from "../functions";
import { showPreloader, hidePreloader, clearData } from './ajaxFunctions'
import ajaxListData from './ajaxListData'

const ajaxFilter = (value) => {
  showPreloader();

  const data = {
    action: "my_action",
    security: MyAjax.security,
    tax: value["tax"],
    search: value["search"],
  };

  $.post(MyAjax.ajaxurl, data, (response) => {
    hidePreloader();
    if (response.data === "empty") {
      returnEmptySearchMsg();
      console.log("Nessun risultato corrisponde alla tua ricerca.");
    } else {
      clearData();
      hidePreloader();
      ajaxListData(response.data);
      console.log(response.data.results.length + " risultati corrispondono alla tua ricerca.");
    }
  }).fail((error) => {
    hidePreloader();
    console.log(error);
    console.log(error.catch);
  });
};
export default ajaxFilter;
